import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ReadResidentsChangeLogFiltersQuery from 'features/residents/models/read-residents-change-log-filters-query';
import ReadResidentsChangeLogFiltersResponse from 'features/residents/models/read-residents-change-log-filters-response';

const residentBaseUrl = '/api/v1/resident';

enum ResidentsChangeLogQueryPaths {
  ReadResidentsChangeLogFilters = 'ReadResidentsChangeLogFilters',
}

const readResidentsChangeLogFilters = async (
  axiosInstance: AxiosInstance,
  readResidentsChangeLogFiltersQuery: ReadResidentsChangeLogFiltersQuery,
): Promise<ReadResidentsChangeLogFiltersResponse> => {
  const response = await axiosInstance.post(
    `${residentBaseUrl}/${ResidentsChangeLogQueryPaths.ReadResidentsChangeLogFilters}`,
    readResidentsChangeLogFiltersQuery,
  );
  return response.data;
};

export const useReadResidentsChangeLogFilters = (readResidentsChangeLogFiltersQuery: ReadResidentsChangeLogFiltersQuery) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [ResidentsChangeLogQueryPaths.ReadResidentsChangeLogFilters, readResidentsChangeLogFiltersQuery],
    queryFn: () => readResidentsChangeLogFilters(authenticatedInstance, readResidentsChangeLogFiltersQuery),
  });
};
